var profileEdit = { 
	
	init : function(){
		$('.nav-tabs a').click(function(){
			var label = $(this).data('label');
			$('.nav-trigger span').html(label);
			$('.nav-tabs').removeClass('open');
		});
		$('.nav-trigger').click(function(e){
			$('.nav-tabs').toggleClass('open');
			e.preventDefault();
		});
	},

    disconnectAccount : function($this){
        $.ajax({
            type: "POST",
            url: "/api/disconnect-social-account",
            data: {
                provider: $this.data('provider')
            },
            success:function(data){
                window.location.reload();
            }
        });
        return false;
    }
};
var UserAvatar = {
    filename : null,
    original_filename : null,
    init : function(target){

        var $this = this;

        $('#'+target + '-save').on('click',function(){
            if($this.filename != null){
                $.ajax({
                    
                    type : "POST",               
                    url  : "/users/avatar",
                    
                    data: { 
                        filename            : $this.filename,
                        original_filename : $this.original_filename
                    },

                    success:function(data){
                       window.location.reload();
                    }
 
                });
            }else{
                alert('select an image first');
            }
        })

        $('#'+target).closest('.modal').on('shown.bs.modal',function(){

            var uploader = new plupload.Uploader({
                runtimes        : 'html5,flash,silverlight,browserplus',
                browse_button   : target + '-pickfiles',
                container       : target + '-container',
                drop_element    : target + '-dropzone',
                url             : '/upload',
                headers:{
                    'X-CSRF-TOKEN':$('meta[name="csrf-token"]').attr('content')
                },
                filters : {
                    max_file_size : '3mb',
                    mime_types: [
                        {title : "Images", extensions : "jpg,jpeg,png"}
                    ]
                }
            });

            $('#'+target + '-uploadfiles').click(function(e) {
                uploader.start();
                e.preventDefault();
            });

            uploader.init();

            uploader.bind('FilesAdded', function(up, files) {

                $.each(files, function(i, file) {
                    var markup = '	<div id="' + file.id + '"><p style="    text-overflow: ellipsis;overflow: hidden;">'+file.name+'<br/>' + plupload.formatSize(file.size) + '</p>\
                                    <div class="progress progress-small" style="display:none;height:6px;">\
                                        <div class="progress-bar progress-bar-danger" style="    background-color: rgb(34, 137, 233);width: 0%;"></div>\
                                    </div>';
                    $('#'+target + '-uploaded-files').html(markup);
                });
                up.refresh();

                uploader.start();
            });

            uploader.bind('UploadProgress', function(up, file) {
                $('#' + file.id + " .progress").fadeIn('fast');
                $('#' + file.id + " .progress .progress-bar").width(file.percent + "%");
            });

            uploader.bind('Error', function(up, err) {

                AjaxForms.form_submit_response("Message: " + err.message + (err.file ? ", File: " + err.file.name : "") ,'error');
                up.refresh();

            });

            uploader.bind('FileUploaded', function(up, file,ee) {
                var response = (JSON.parse(ee.response));
                $('#' + target + '-dropzone').css("background", "transparent url('/tmp/50/50/"+response.path+"') no-repeat 50% 50%");
                $('#' + target + '-dropzone').css("background-size", "cover");
                $('#' + file.id + " .progress").fadeOut('fast');
               
                $this.filename          = response.path;
                $this.original_filename = file.name;
            });
        })


    }
};

var accountSearchForm = function(form) {
    $(form).parsley();
    $(form).on('submit',function($e){   
        var $q = $(form + ' input[name="q"]').val();
        $(form).closest('.partial').data('q', $q);
        load_partial($(form).closest('.partial'));
        return false;       
    });
};

var editUsersForm = function() {
    $('.users-item-save').click(function(){        
        $(this).closest('.user-item').find('.hidden-on-edit').addClass('hidden');
        $(this).closest('.user-item').find('.visible-on-edit').removeClass('hidden');
        return false;
    });  
};

var editSubmissionsForm = function() {
    $('.users-edit-submission').click(function(){     
        var id = $(this).data('id');   
        $.ajax({  
            url      : '/partial/account.submissions.edit-submission?id='+id,                         
            success: function (data) {   
                $('#modal').html(data.markup);    
                $('body').addClass('dark-backdrop');
                $('#modal').modal('show');
                $('#modal').on('hidden.bs.modal', function () {
                    $('#modal').empty();
                    $('body').removeClass('dark-backdrop');
                });
 
            },
            error:function(d){

            }
        });
        return false;
    });  
};


var dashboardSort = function(target) {
    var caller = $(target),
    partial = caller.closest('.partial');
    partial.data('sort_term',caller.data('name').trim());
    partial.data('sort_way',caller.attr('rel').trim());
    load_partial(partial);
    return false;
};

var submissionsOptions = {
    init : function(){    
        $('.timeline').each(function() {
            var $this = $(this).data('id');
            var timeline =$(this).data('timeline');
             
            var options = {
               seriesBarDistance: 12,
              distributeSeries: true,
              height: '200px',
              showPoint: false,
              low: 0,
              showArea: true,
              stretch: true,
              plugins: [
                Chartist.plugins.tooltip()
              ],
              axisX: {
                showLabel: false,
                onlyInteger: false
              },
              axisY: {
                     onlyInteger: true
                 }
            };

            var responsiveOptions = [
              ['screen and (min-width: 640px)', {
                
              }]
            ];
          

           var chart =  new Chartist.Bar($this, timeline, options, responsiveOptions);

           
         
        });

    }  
};
